// Styles
import './editorial-carousel.scss';;
import { throttle } from '../../scripts/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFeaturedCarousel = (context) => {
  const carousel_banner = context.closest('.shopify-section');

  if (carousel_banner) {
    const slider = carousel_banner.querySelector('[data-editorial-carousel-master]');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 24,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
        snapOnRelease: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
       breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 48
        }
      }
    });

    const image = context.querySelector('.editorial-tile__image');
    const arrows = carousel_banner.querySelectorAll('.swiper-navigation');

    if(image && arrows.length) {
      const updateArrowPosition = function(arrow) {
        arrow.style.top = `${image.clientHeight / 2}px`;
      }

      window.addEventListener('resize', throttle(() => Array.from(arrows).map(updateArrowPosition), 200));
      Array.from(arrows).map(updateArrowPosition);
    }
  }
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.editorial-carousel__blocks-container.carousel-container'), (el) => {
    window.dAgency.initFeaturedCarousel(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.editorial-carousel__blocks-container.carousel-container'), (el) => {
      window.dAgency.initFeaturedCarousel(el);
    });
  });
}
